import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from './components/nuxt-error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_bootstrapvue_e2e276f0 from 'nuxt_plugin_bootstrapvue_e2e276f0' // Source: ./bootstrap-vue.js (mode: 'all')
import nuxt_plugin_portalvue_76dd66cc from 'nuxt_plugin_portalvue_76dd66cc' // Source: ./portal-vue.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_1e741d01 from 'nuxt_plugin_cookieuniversalnuxt_1e741d01' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_deviceplugin_7b8d7de4 from 'nuxt_plugin_deviceplugin_7b8d7de4' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_workbox_91375b96 from 'nuxt_plugin_workbox_91375b96' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_72769448 from 'nuxt_plugin_metaplugin_72769448' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_toast_131a9c08 from 'nuxt_plugin_toast_131a9c08' // Source: ./toast.js (mode: 'client')
import nuxt_plugin_axios_46ea4f59 from 'nuxt_plugin_axios_46ea4f59' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_axios_5659d192 from 'nuxt_plugin_axios_5659d192' // Source: ../plugins/axios.js (mode: 'all')
import nuxt_plugin_spotifyAPI_561c6941 from 'nuxt_plugin_spotifyAPI_561c6941' // Source: ../plugins/spotifyAPI.js (mode: 'all')
import nuxt_plugin_axiosS3_234cd612 from 'nuxt_plugin_axiosS3_234cd612' // Source: ../plugins/axiosS3.js (mode: 'all')
import nuxt_plugin_fontawesome_b8db358e from 'nuxt_plugin_fontawesome_b8db358e' // Source: ../plugins/fontawesome.js (mode: 'all')
import nuxt_plugin_gtagGA4_24b2d0a6 from 'nuxt_plugin_gtagGA4_24b2d0a6' // Source: ../plugins/gtagGA4.js (mode: 'client')
import nuxt_plugin_auth_6794ea92 from 'nuxt_plugin_auth_6794ea92' // Source: ./auth.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"drops","script":[{"src":"https:\u002F\u002Fwww.googletagmanager.com\u002Fgtag\u002Fjs?id=undefined","async":true}],"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"Drops is an Augmented Reality Marketing Platform for creating web-based AR experiences in minutes. Drops allows users to easily create, send and share multi-sensory Augmented Reality Experiences that include 3D visuals and streaming music or audio. With the Drops AR creation tool, marketers can build customizable Augmented Reality scenes and virtual gifts with no coding or design experience. These experiences can be shared in just a few clicks."}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Raleway"}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_bootstrapvue_e2e276f0 === 'function') {
    await nuxt_plugin_bootstrapvue_e2e276f0(app.context, inject)
  }

  if (typeof nuxt_plugin_portalvue_76dd66cc === 'function') {
    await nuxt_plugin_portalvue_76dd66cc(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_1e741d01 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_1e741d01(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_7b8d7de4 === 'function') {
    await nuxt_plugin_deviceplugin_7b8d7de4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_91375b96 === 'function') {
    await nuxt_plugin_workbox_91375b96(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_72769448 === 'function') {
    await nuxt_plugin_metaplugin_72769448(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toast_131a9c08 === 'function') {
    await nuxt_plugin_toast_131a9c08(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_46ea4f59 === 'function') {
    await nuxt_plugin_axios_46ea4f59(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_5659d192 === 'function') {
    await nuxt_plugin_axios_5659d192(app.context, inject)
  }

  if (typeof nuxt_plugin_spotifyAPI_561c6941 === 'function') {
    await nuxt_plugin_spotifyAPI_561c6941(app.context, inject)
  }

  if (typeof nuxt_plugin_axiosS3_234cd612 === 'function') {
    await nuxt_plugin_axiosS3_234cd612(app.context, inject)
  }

  if (typeof nuxt_plugin_fontawesome_b8db358e === 'function') {
    await nuxt_plugin_fontawesome_b8db358e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gtagGA4_24b2d0a6 === 'function') {
    await nuxt_plugin_gtagGA4_24b2d0a6(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_6794ea92 === 'function') {
    await nuxt_plugin_auth_6794ea92(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
